

































































































    import {
        DisplayModule,
        RouterModule,
        SectionsModule,
        VotingModule,
        UsersModule,
        DocumentsModule, CommentsModule, ArgumentsModule,
    } from '@/store/store.helper';
    import {SectionInterface, VotesInterface} from '@/types/interfaces';
    import * as enums from '@/types/enums';
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import moment from 'moment';
    import {colorDirective} from '@/directives/color-directive';
    import {Prop} from 'vue-property-decorator';
    import AddNew from '../../add.new/add.new';
    import {eventBus} from "@/main";
    import * as VueScrollTo from 'vue-scrollto';

    @Component({
        directives: {
            colorDirective,
        },
        components: {
            AddNew
        },
        props: {},
    })
    export default class CardVoting extends Vue {
        @Prop() public section: SectionInterface;
        @Prop() public sectionIndex: Number;
        @Prop() public parentSectionId: String;
        @Prop() public pageStatus: Number;
        @Prop() public open: Boolean;
        @Prop() public isRejectedFeed: Function;
        @Prop() public isDisplayed: Boolean;
        @Prop() public isEditFeed: Boolean;
        @Prop() public isUserEditor: Boolean;

        @RouterModule.RouterGetter public currentRoute;
        @RouterModule.RouterGetter public getPath;
        @RouterModule.RouterAction private push;

        @DisplayModule.DisplayMutation public setNavBar;
        @DisplayModule.DisplayGetter public scrollingOptions;

        @DocumentsModule.DocumentsGetter private documentId;
        @DocumentsModule.DocumentsGetter private documentHideCounter;

        @SectionsModule.SectionsGetter public isParentSection;
        @SectionsModule.SectionsGetter private getDeadline: (Date) => number;
        @SectionsModule.SectionsGetter private isDynamicFeed: (pageStatus) => boolean;
        @SectionsModule.SectionsGetter private isSectionsInRevisions;

        @UsersModule.UsersGetter private userUid;
        @UsersModule.UsersGetter private isSignedIn;
        @UsersModule.UsersGetter private participantDisplayNameById;
        @UsersModule.UsersAction private checkUserProperties;
        @UsersModule.UsersAction private signIn;

        @VotingModule.VotingGetter private isUserVoted;
        @VotingModule.VotingGetter private votingOptionsKeys;
        @VotingModule.VotingGetter private isSectionReachedToThreshold: (
            SectionInterface,
            VotesInterface,
        ) => boolean;
        @VotingModule.VotingAction private addVote: ({
                                                         section: SectionInterface,
                                                         vote: VOTING_OPTIONS,
                                                     }) => VotesInterface;
        @VotingModule.VotingAction private updateConsensusAndThreshold: ({
                                                                             updatedVotes: VotesInterface,
                                                                             section: SectionInterface,
                                                                             parentSectionId: string,
                                                                         }) => Promise<any>;
        @VotingModule.VotingAction private endVoting: ({
                                                           updatedVotes: VotesInterface,
                                                           section: SectionInterface,
                                                           parentSectionId: string,
                                                           sectionIndex: number,
                                                       }) => Promise<any>;

  @ArgumentsModule.ArgumentsGetter private argumentBySectionId;
  @CommentsModule.CommentsGetter private commentsBySectionId;

  private loading: boolean = false;
  public deadline = '';
  public action: number | string;
  public isShowNew: boolean = false;
  public objectToAdd = '';
  public mutedParentSectionId = this.parentSectionId;

  private buttonSize() {
    const size = {xs:'x-small',sm:'small', md: 'large', lg:'large',xl:'x-large'}[this.$vuetify.breakpoint.name];
    return size ? { [size]: true } : {}
  }

  public mounted() {
    this.getTimer(this.section.deadline, this.section.timer);
    eventBus.$on('closeBox', () => {
      this.isShowNew = false;
    });
  }
    private beforeDestroy() {
        eventBus.$off('closeBox');
    }

  private showThreshold() {
    console.log('show threshold: ', this.section.status)
    return this.isDynamicFeed(this.pageStatus) && this.section.status !== enums.SECTION_STATUS.approved
  }
  /**
   * adding vote to section
   * @param {string} vote
   */
  private async voteClicked(vote: string) {// user has voted
    this.$ga.event('info', this.documentId, 'vote', 0); // Google Analytics
    this.loading = true; // Loading visualization
    await this.$emit('userVoted', vote); // Send vote event to Section-Card parent
    this.loading = false;
  }

        /**
         * get number of comments
         */
        get countComments() {
            return this.argumentBySectionId(this.section.id).length + this.commentsBySectionId(this.section.id).length;
        }

        /**
         * navigate to section page
         * @param {number} index the index of the section
         * @param {SectionInterface} section
         * @param {number} status
         *
         */
/*        private async navigateToSectionPage() {
            let sectionId;
            if (this.section.toEdit && this.section.toEdit.length > 0) {
                sectionId = this.section.id;
            } else if (this.parentSectionId !== '0') {
                sectionId = this.parentSectionId;
            }
            const path = this.getPath({
                name: enums.ROUTE_NAME.section,
                params: {
                    [enums.SECTION_BY.sectionsByStatus]: enums.FEED_TYPE.toEdit,
                    index: this.editSuggestions.length,
                    id: sectionId,
                },
            });
            this.setNavBar({path: this.currentRoute.fullPath});
            this.push({path});
        }*/

        public getTimer(deadline, timer) {
            const that = this;
            return setInterval(function () {
                const distance = that.getDeadline(deadline);
                let days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
                let hours = Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
                ).toString();
                let minutes = Math.floor(
                    (distance % (1000 * 60 * 60)) / (1000 * 60),
                ).toString();
                let seconds = Math.floor((distance % (1000 * 60)) / 1000).toString();
                days = days.length === 1 ? '0' + days : days;
                hours = hours.length === 1 ? '0' + hours : hours;
                minutes = minutes.length === 1 ? '0' + minutes : minutes;
                seconds = seconds.length === 1 ? '0' + seconds : seconds;
                if (distance < 0) {
                    return 'EXPIRED';
                }
                that.deadline = seconds + ' : ' + minutes + ' : ' + hours + ' : ' + days;
            }, 1000);
        }

        private async addNewArgument(action) {
            if (!this.isSignedIn) {
                this.signIn();
            } else {
                this.objectToAdd = 'argument';
                this.action = action;
                this.isShowNew = false;
                this.isShowNew = true;
                eventBus.$emit('nextBtn', false);
            }
        }

        private async addNewSection() {
            if (!this.isSignedIn) {
                this.signIn();
            } else {
                this.mutedParentSectionId = this.section.id!;
                this.objectToAdd = 'section';
                this.action = enums.SECTION_STATUS.toEditInTheVote;
                this.isShowNew = false;
                this.isShowNew = true;
                eventBus.$emit('nextBtn', false);
            }
        }

        private isSectionStatusToEditInTheVote() {
            return this.section.status === enums.SECTION_STATUS.toEditInTheVote || this.section.status === enums.SECTION_STATUS.toEdit
        }
    }
